import { observer } from 'mobx-react-lite';
import React from 'react';

import { Button } from 'src/domains/common/components/button/button';
import { BetTickerBoxState } from './BetTickerBox.state';
import { Banner } from './Banner';
import { VirtualizedTableV2 } from './VirtualizedTable';
import { BetTickerForm } from './BetTickerForm/BetTickerForm';
import { BetTickerV2State } from 'src/domains/sportsbook/trading/view/bet-ticker/BetTickerV2.state';
import { useCommon } from 'src/AppState/Common';

type BetTickerBoxPropType = {
    betTickerState: BetTickerV2State;
};

const BET_TICKER_PRESETS_ALL = [
    { label: 'All bets', rules: {} },
    { label: 'All bets £25+', rules: { betsAbove: 25 } },
    { label: 'Single bets', rules: { betType: 'SGL' } },
    { label: 'Desktop bets', rules: { channel: 'desktop' } },
    { label: 'All Horse Racing', rules: { sport: [{ id: 'horseracing', competitions: true }] } },
    { label: 'All Football', rules: { sport: [{ id: 'football', competitions: true }] } },
    { label: 'Restricted Clients', rules: { stakeFactor: 1, stakeFactorCondition: '<' } },
    {
        label: 'Greyhound FC/TC',
        rules: { betsType: ['FC', 'RFC', 'CFC', 'TC', 'CTC'], sport: [{ id: 'greyhoundracing', competitions: true }] },
    },
    { label: 'Custom' },
    { label: 'All Rejected Bets', rules: { rejectedBets: true } },
    { label: 'All Free Bets', rules: { freebet: true } },
    { label: 'Cash Out bets', rules: { cashOutBets: true } },
];

export const BetTickerBox = observer((props: BetTickerBoxPropType) => {
    const common = useCommon();
    const { betTickerState } = props;
    const [state] = React.useState(() => new BetTickerBoxState(betTickerState, common));

    if (state.rules !== null)
        return (
            <div className='rounded-md border border-border border-solid w-full shadow-sm h-full flex-grow'>
                <div className='w-full h-full'>
                    <div className='flex flex-col h-full relative gap-2'>
                        <Banner
                            title={state.title}
                            settings={state.settingsLabel}
                            sports={state.sportsLabel}
                            onClose={() => state.clearAll()}
                        />
                        <div className='flex h-full overflow-x-auto px-2 overflow-y-hidden pb-3'>
                            <VirtualizedTableV2
                                data={state.filteredBets}
                                columns={state.columns}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    else if (state.custom === true)
        return (
            <BetTickerForm
                onClose={() => {
                    state.clearAll();
                    state.setCustom(false);
                }}
                onSubmit={(rules, config) => {
                    state.setRules(rules);
                    state.setConfig(config);
                }}
                store={betTickerState.competitionStore}
                sportsResource={betTickerState.allSports}
            />
        );
    else
        return (
            <div className='rounded-md border border-border border-solid w-full overflow-y-auto custom-scrollbar shadow-sm h-full flex flex-grow items-center justify-center'>
                <div className='w-full max-h-full'>
                    <div className='flex flex-col gap-2 py-2 items-center justify-center self-center font-normal'>
                        {BET_TICKER_PRESETS_ALL.map((button) => {
                            return (
                                <Button
                                    key={button.label}
                                    variant='outline'
                                    className='w-[320px] font-normal'
                                    onClick={() => {
                                        if (button.label === 'Custom') state.setCustom(true);
                                        else if (button.rules !== undefined) state.setRules(button.rules);
                                        state.setTitle(button.label);
                                    }}
                                >
                                    {button.label}
                                </Button>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
});
